/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCloudAccessPolicy {
    getFixupPrototypeFunction() { return ServiceAccountCloudAccessPolicy.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCloudAccessPolicy>): ServiceAccountCloudAccessPolicy {
        let obj = Object.assign(new ServiceAccountCloudAccessPolicy(), model);
        ServiceAccountCloudAccessPolicy.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCloudAccessPolicy>): ServiceAccountCloudAccessPolicy {
        if (!model) return null;
        return ServiceAccountCloudAccessPolicy.newInstance(<ServiceAccountCloudAccessPolicy> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCloudAccessPolicy) {
        if (!obj) return;

        models.ServiceAccountCloudAccessPolicy.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCloudAccessPolicy): boolean {
        Object.setPrototypeOf(obj, ServiceAccountCloudAccessPolicy.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Cloud access type to select
     */
    access_type: models.CloudAccountAccessType;

    /**
     * Cloud Access Policy
     */
    access_policy: string;

}
